import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { BlogCategory } from '@shared/models/blog-category.model';
import { BlogService } from '../services/blog.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CategoryResolver  {
  constructor(private blogService: BlogService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<BlogCategory> | Promise<BlogCategory> | BlogCategory {
    if (route.queryParams?.index) {
      this.router.navigate([`${route.paramMap.get('category')}/page/${route.queryParams.index}`]);
    }

    return this.blogService.getCategoryBySlug(route.paramMap.get('category'));
  }
}
